export default __webpack_public_path__ + "static/joseCarrero-af2529ce6bb999334e4cf3c75fb30f88.png";